import startCase from 'lodash/startCase'
import upperCase from 'lodash/upperCase'

import React from 'react'
import { PRO } from '@disco/state-management/selectors/business'
import DocumentHeadTags from 'components/document-head-tags'
import Alert from 'components/ui/alert'
import ContactUsLink from 'components/ui/contact-us-link'
import PageContainer from 'components/ui/page-container'
import PageHeader from 'components/ui/page-header'
type Props = {
  ddex_distributor?: string
  isFeatureEnabled: boolean | null | undefined
  isTrial: boolean
}

const DDEXSettings = ({
  ddex_distributor,
  isFeatureEnabled,
  isTrial,
}: Props): React.ReactNode => {
  let alertContent = (
    <>
      Distributor ingestion is available on our {upperCase(PRO)}
      &nbsp;plan.
      <br />
      <ContactUsLink intercomMsg="I’d like to discuss upgrading to PRO for access to DDEX ingestions">
        {isTrial
          ? `Signup to ${startCase(PRO)}`
          : `Upgrade to ${upperCase(PRO)}`}
      </ContactUsLink>
    </>
  )

  if (isFeatureEnabled) {
    alertContent = (
      <>
        {ddex_distributor
          ? 'To change or remove this feed, please'
          : 'Ready to set up your feed?'}
        <br />
        <ContactUsLink
          intercomMsg={
            ddex_distributor
              ? 'I would like to change selected DDEX distributor'
              : 'I would like to set up DDEX import.'
          }
        >
          Contact us
        </ContactUsLink>
      </>
    )
  }

  return (
    <>
      <DocumentHeadTags title="Settings | DDEX | DISCO" />
      <PageHeader title="Distributor ingestion" />
      <PageContainer>
        <div className="InboxList_TrialMessage">
          {isFeatureEnabled && ddex_distributor ? (
            `You are currently importing releases from ${ddex_distributor}.`
          ) : (
            <>
              DISCO can import files directly from your distributor.
              <br />
              We currently work with the following distributors:
              <br />
              <ul>
                <li>FUGA</li>
                <li>AudioSalad</li>
                <li>IDOL</li>
                <li>CI</li>
              </ul>
              Distributor not on the list? Contact us and we can see if it’s
              possible to set up a feed.
            </>
          )}
        </div>
        <br />
        <Alert icon="warning" status="warning">
          {alertContent}
        </Alert>
      </PageContainer>
    </>
  )
}

export default DDEXSettings
